"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const infobox_1 = require("@completeanatomy/infobox");
const model_interactions_1 = require("@completeanatomy/model-interactions");
const MainPageLayout_1 = __importDefault(require("../../templates/MainPageLayout"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const auth_1 = require("@completeanatomy/auth");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const heart_panel_1 = require("@completeanatomy/heart-panel");
const model_systems_1 = require("@completeanatomy/model-systems");
const models_1 = require("@completeanatomy/models");
const tools_1 = require("@completeanatomy/tools");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
function MainPage() {
    var _a;
    const bridge = (0, bridge_1.useBridge)();
    const { isMobile } = (0, device_1.usePlatform)();
    const selectedModel = (0, models_1.useSelectedModel)();
    const isDetailed = (0, models_1.useIsDetailedModel)();
    const isResetButtonActive = (0, model_systems_1.useIsSystemsResetAvailable)();
    const currentUser = (0, user_1.useUser)();
    const isLogged = !(currentUser === undefined || currentUser === null);
    const tools = (0, tools_1.useToolsService)();
    const labelToolManager = (_a = tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager()) !== null && _a !== void 0 ? _a : null;
    const previousModelRef = (0, react_1.useRef)(selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name);
    (0, react_1.useEffect)(() => {
        if (previousModelRef.current !== (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name)) {
            // Model has changed, so reset labels
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.setLabelsState([]);
        }
        previousModelRef.current = selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name]);
    const onReset = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.resetAllSystems();
    };
    const region = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name) || '';
    const mode = (0, i18n_1.Localized)(isDetailed ? i18n_1.Strings.detailedModelMode.title : i18n_1.Strings.regionMode.title);
    const modelType = (0, models_1.useModelType)();
    const isFullBody = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.mask) === bridge_schema_1.BodyRegionMask.Default &&
        (modelType === bridge_schema_1.ModelType.Male || modelType === bridge_schema_1.ModelType.Female);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(MainPageLayout_1.default, { left: (0, jsx_runtime_1.jsx)(infobox_1.InfoBox, { withHeader: !isFullBody }), header: (0, jsx_runtime_1.jsx)(StyledHeader, { type: ui_1.HeaderType.Default, "$isVisible": !isFullBody, children: (0, jsx_runtime_1.jsx)(ui_1.ContentTitle, { title: isMobile ? region : mode, subtitle: isMobile ? '' : (0, jsx_runtime_1.jsx)("span", { children: region }), isResetButtonVisible: !!isResetButtonActive, onReset: onReset }) }), children: [(0, jsx_runtime_1.jsx)(model_interactions_1.NavigationToolbar, { isFullBody: isFullBody }), (0, jsx_runtime_1.jsx)(heart_panel_1.BeatingHeartHint, {}), !isLogged && (0, jsx_runtime_1.jsx)(StyledAuthButtonsPanel, {})] }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] }));
}
exports.MainPage = MainPage;
const StyledHeader = (0, styled_components_1.default)(ui_1.Header) `
  z-index: 0;

  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
`;
const StyledAuthButtonsPanel = (0, styled_components_1.default)(auth_1.AuthButtonsPanel) `
  position: absolute;
  right: 10px;

  top: calc(20px + env(safe-area-inset-top));
  top: calc(20px + constant(safe-area-inset-top));

  ${ui_1.device.laptopS `
    bottom: 100px;
    right: 85px;
    top: inherit;
  `};
`;
